import Footer from '../components/Footer'
import { Collection, Hero, LiveBadge, SellWatch, Social } from '../components/HomeSections'
import Seo from '../components/Seo'

export default function Home() {
  return (
    <main>
      <Seo />
      <Hero />
      <LiveBadge />
      <Collection />
      <SellWatch />
      <Social />
      <Footer />
    </main>
  )
}

